<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Parent Account Code Groups &nbsp;
          <add-button
            link="/procurement-management/parent-account-code-groups/create"
          ></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Parent Account Code Groups</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportparent_account_code_groups.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="parent_account_code_groups_excel"
                    :fields="excel_fields"
                    worksheet="Parent Account Code Groups"
                    name="Parent Account Code Group.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Owner</th>
                    <th>Parent Account Name</th>
                    <th>Parent Account Code</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="parent_account_code_groups.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr
                    v-for="(
                      parent_account_code_group, at
                    ) in parent_account_code_groups"
                    :key="`parent_account_code_group${at}`"
                  >
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ parent_account_code_group.owner.name }}</td>
                    <td>{{ parent_account_code_group.parent_account_name }}</td>
                    <td>{{ parent_account_code_group.parent_account_code }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/parent-account-code-groups/${parent_account_code_group.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(parent_account_code_group.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "parent_account_code_group",
  data() {
    return {
      parent_account_code_groups: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      parent_account_code_groups_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Owner: "owner",
        "Parent Account Name": "parent_account_name",
        "Parent Account Code": "parent_account_code",
      },
      Exportparent_account_code_groups: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let parent_account_code_groups = await axios.get(
        `/parent_account_code_groups?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.parent_account_code_groups = parent_account_code_groups.data.data;
      this.count = parent_account_code_groups.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let parent_account_code_groups = await axios.get(
        `/parent_account_code_groups?search=${this.searchData}`
      );
      this.parent_account_code_groups = parent_account_code_groups.data.data;
      this.count = parent_account_code_groups.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Parent Account Code Groups Data";
      this.parent_account_code_groups_excel = [];
      let Exportparent_account_code_groups = [];
      Exportparent_account_code_groups = await axios.get(
        `/parent_account_code_groups`
      );
      this.Exportparent_account_code_groups =
        Exportparent_account_code_groups.data.data;
      let sr_no = 1;
      this.Exportparent_account_code_groups.forEach(
        (parent_account_code_group) => {
          this.parent_account_code_groups_excel.push({
            sr_no: sr_no,
            parent_account_name: parent_account_code_group.parent_account_name
              ? parent_account_code_group.parent_account_name
              : "",
            parent_account_code: parent_account_code_group.parent_account_code
              ? parent_account_code_group.parent_account_code
              : "",
            owner: parent_account_code_group.owner
              ? parent_account_code_group.owner.name
              : "",
          });
          sr_no++;
        }
      );
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(
            `delete?id=${id}&table_name=parent_account_code_groups`
          );
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
